<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="vs-sidebar--item"
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
  >
    <router-link
      tabindex="-1"
      v-if="changedTo"
      exact
      :class="[{ 'router-link-active': activeLink }]"
      style="position: sticky"
      :to="changedTo"
      :target="target"
    >
      <menu-icon :featherIcon="featherIcon" :icon="icon" :iconSmall="iconSmall" />
      <slot />
    </router-link>

    <a v-else :target="target" :href="href" :class="[{ 'router-link-active': activeLink }]" tabindex="-1">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon
        v-else-if="!!icon"
        :class="{ 'w-3 h-3': iconSmall }"
        :icon="icon"
      />
      <img
        v-else
        src="@/assets/images/icon/icon-circle-line-white.svg"
        alt="circle"
        class="mr-3"
      />
      <slot />
    </a>
  </div>
</template>

<script>
import MenuIcon from './MenuIcon.vue';
export default {
  name: "v-nav-menu-item",
  components:{
    MenuIcon
  },
  props: {
    item: Object,
    icon: { type: String, default: "" },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: "material-icons" },
    href: { type: [String, null], default: "#" },
    to: { type: [String, Object, null], default: null },
    activeCode: { type: String, default: null },
    index: { type: [String, Number], default: null },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: "_self" },
    isDisabled: { type: Boolean, default: false },
    groupName: {
      type: Array,
      default: () => {
        return [];
      },
    },
    submenu: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    activeLink() {
      let active = !!((this.href === this.$route.path || this.$route.meta.activeCode === this.activeCode) && (this.changedTo || this.href));
      const pathList = this.$route.path.split("/");

      // note 옵션 체크
      try {
        const note = JSON.parse(this.item.note);
        if (note.onlyAdmin && !this.isAdmin) {
          return false;
        }
      } catch (e) {}

      if (this.activeCode) {
        const activeCode = this.activeCode
        const __index_field = pathList.indexOf('field');
        const __check_field_code = (pathList.length > __index_field + 1) ? pathList[__index_field + 1] : '_none_';
        if (`field-${__check_field_code}` === activeCode) active = true;
      }

      if (this.groupName) {
        this.groupName.map((boardId) => {
          const __index_tab = pathList.indexOf('tab');
          const __check_tab_code = (pathList.length > __index_tab + 1) ? pathList[__index_tab + 1] : '_none_';
          let __check_tab_page_type = (pathList.length > __index_tab + 2) ? pathList[__index_tab + 2] : '';
          __check_tab_page_type = __check_tab_page_type === 'write' ? '' : __check_tab_page_type;
          const __check_board_id = `${__check_tab_code}${__check_tab_page_type ? `/${__check_tab_page_type}` : ''}`
          if (boardId === __check_board_id) active = true;
        });
      }

      // 현재 접속한 페이지가 submenu 에 있는 경우 activeLink 를 true 로 설정
      if (this.submenu.length > 0) {
        const func = (menu) => {
          for (let i = 0; i < menu.length; i++) {
            const item = menu[i];

            // note 옵션 체크
            try {
              const note = JSON.parse(item.note);
              if (note.onlyAdmin && !this.isAdmin) {
                return false;
              }
            } catch (e) {}

            if (item.url && item.url === this.$route.path) active = true;

            // write 페이지 일 경우
            const __index_tab = pathList.indexOf('tab');
            const __check_tab_page_type = (pathList.length > __index_tab + 2) ? pathList[__index_tab + 2] : '';
            if (__check_tab_page_type === 'write' && item.url && this.$route.path.indexOf(item.url) >=0 ) active = true;

            if (!active && menu[i].submenu) {
              func(menu[i].submenu);
            }
          }
        }
        func(this.submenu);
      }

      if (this.href === this.$route.path) {
        active = true;
      }

      return active;
    },
    changedTo () {

      // 하나 이상인 모든 submenu 의 visible 이 'tab' 이면 첫번째 submenu 의 url 로 이동
      if (this.submenu.length > 0) {
        // 모두 tab 인지 확인
        const isAllTab = this.submenu.every((item) => item.visible === 'tab');

        // 첫번째 submenu 의 url 로 이동
        if (isAllTab) {
          return this.submenu[0].url;
        }
      }

      return this.to;
    },

    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },

  },
};
</script>

<style>
.vs-sidebar-item-active > a {
  background-color: #7367f0;
  color: #fff;
  border-radius: 0.5rem;
}
</style>
